module.exports = __webpack_public_path__ + "img/ic_pembelajaran.aaea7a22.svg";